import unBilledQueryApi from '@/api/unBilledQuery/unBilledQueryApi.js';

export default {
	name: 'un-billed-query',
	mixins: [],
	extends: {},
	components: {},
	props: [],
	data() {
		return {
			baseUrl:'',
			getUnBilledResp: {
				ftBillCycle:'',
				fees:'',
			},
		};
	},
	computed: {
		
	},
	watch: {},
	created() {},
	mounted() {
		this.init();
	},
	updated() {},
	beforeDestroy() {},
	methods: {
		async init() {
			this.getUnBilledResp = await unBilledQueryApi.getUnBilled();
		},

		parseDuration(duration) {
			if (duration) {
				let totalSec = parseInt(duration);
				let min = Math.floor(totalSec / 60);
				let sec = totalSec % 60;
				if (min > 0) {
					return min + '分' + sec + '秒';
				} else {
					return sec + '秒';
				}
			} else {
				return '--';
			}
		}
	},
};



// WEBPACK FOOTER //
// ./src/components/unBilledQuery/unBilledQuery.js